export const GET_STEPS_CONFIGURATION = "STEPS_CONFIGURATION/GET_STEPS_CONFIGURATION";
export const GET_STEPS_CONFIGURATION_SUCCESS = "STEPS_CONFIGURATION/GET_STEPS_CONFIGURATION_SUCCESS";
export const GET_STEPS_CONFIGURATION_FAILED = "STEPS_CONFIGURATION/GET_STEPS_CONFIGURATION_FAILED";
export const UPDATE_STEPS_CONFIGURATION = "STEPS_CONFIGURATION/UPDATE_STEPS_CONFIGURATION";
export const UPDATE_STEPS_CONFIGURATION_SUCCESS = "STEPS_CONFIGURATION/UPDATE_STEPS_CONFIGURATION_SUCCESS";
export const UPDATE_STEPS_CONFIGURATION_FAILED = "STEPS_CONFIGURATION/UPDATE_STEPS_CONFIGURATION_FAILED";
